import { useCookies } from 'vue3-cookies'
import 'dotenv/config'

const AUTH_COOKIE = '_auzer'
const REDIRECT_COOKIE = '_redirreq'

export const GetRequestedRoute = (fallback = '/') => {
    const { cookies } = useCookies()
    return cookies.get(REDIRECT_COOKIE) || fallback
}

export const MarkSessionAuthenticated = () => {
    const { cookies } = useCookies()
    cookies.set(AUTH_COOKIE, 'checker', '1d', '/', '', true, 'Strict')
    cookies.remove(REDIRECT_COOKIE)
}

export const RedirectToLogin = (returnUrl = window.location.pathname + window.location.search + window.location.hash) => {
    const { cookies } = useCookies()
    cookies.set(REDIRECT_COOKIE, returnUrl || '/', '15min', '/', '', true, 'Strict')
    cookies.remove(AUTH_COOKIE)

    const authUrl = process.env.VUE_APP_REST_MAIN_API + '/api/auth/sso?origin=' + encodeURIComponent(window.location.origin)
    window.location.assign(authUrl)
}

export const HasAuthMarker = () => {
    const { cookies } = useCookies()
    return Boolean(cookies.get(AUTH_COOKIE))
}
